import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { LDWDocument } from '../../shared/models/LDWDocument';
import { DocumentHelper } from '../../shared/helpers/document-helper';
import { MatDialog } from '@angular/material/dialog';
import { LdwRouterService } from '../../route/ldw-router.service';
import { TranslateService } from '@ngx-translate/core';
import { InfoService } from '../../shared/services/info.service';
import { ActivatedRoute } from '@angular/router';
import { DocumentHistory } from '../../shared/models/document-history';
import { PdfEditorType } from '../../shared/enums/pdf-editor-type';
import { SettingsService } from '../../shared/settings/settings.service';
import { DocumentDetailResolved } from '../../shared/models/document-detail-resolved';
import { DocumentHistoryResolved } from '../../shared/models/document-history-resolved';
import { combineLatest, Subscription } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
    selector: 'ldw-document-history-detail-page',
    templateUrl: './document-history-detail-page.component.html',
    styleUrls: ['./document-history-detail-page.component.css'],
    standalone: false
})
export class DocumentHistoryDetailPageComponent implements OnInit, OnDestroy {
  private routerService = inject(LdwRouterService);
  private infoService = inject(InfoService);
  private settingsService = inject(SettingsService);
  private route = inject(ActivatedRoute);

  document: LDWDocument | undefined = undefined;
  history: DocumentHistory | undefined = undefined;
  documentHelper: DocumentHelper;
  subscription: Subscription = new Subscription();

  private dialog = inject(MatDialog);
  private translate =  inject(TranslateService);

  constructor() {
    const routerService = this.routerService;

    this.documentHelper = new DocumentHelper(this.dialog, routerService, this.translate);
    this.infoService.clearStatus();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.subscription.add(
      combineLatest([
        this.route.data,
        this.route.paramMap])
        .pipe(
          map(([data, paramMap]) => {
            const documentResolved: DocumentDetailResolved = data['document'];
            const documentHistoryResolved: DocumentHistoryResolved = data['history'];
            const hist = this.route.snapshot.paramMap.get('archived');
            return { documentResolved, documentHistoryResolved, hist }
          }),
          tap((res) => {
            this.SetHistoryDocument(res.documentResolved, res.documentHistoryResolved, res.hist);
          })
        ).subscribe());
  }

  private SetHistoryDocument(documentResolved: DocumentDetailResolved, documentHistoryResolved: DocumentHistoryResolved, hist: string | null) {
    if (documentResolved.documentDetail && documentHistoryResolved.documentHistory) {
      if (hist) {
        this.document = documentResolved.documentDetail;
        this.history = documentHistoryResolved.documentHistory.find(d => d.archived === hist);
      } else {
        this.documentHelper.documentHistoryNotFound();
      }
    }
    else {
      this.error(documentResolved.docId);
    }

    if (documentResolved.error) {
      this.infoService.setStatus(documentResolved.error);
    } else if (documentHistoryResolved.error) {
      this.infoService.setStatus(documentHistoryResolved.error);
    }
  }

  error(docid: string) {
    this.documentHelper.documentNotFound(docid);
  }

  get viewVisible(): boolean {
    return (
      this.document != undefined &&
      this.document.id != '' &&
      this.history != undefined
    );
  }

  public isPdfViewer(): boolean {
    return this.settingsService.settings.pdfSettings.currentEditor().type == PdfEditorType.Viewer;
  }

  public isPdfEditor(): boolean {
    return  this.settingsService.settings.pdfSettings.currentEditor().type == PdfEditorType.Editor;
  }

  public downloadAllowed(): boolean {
    return !this.settingsService.settings.pdfSettings.disableDownload;
  }

  public printingAllowed(): boolean {
    return !this.settingsService.settings.pdfSettings.disablePrinting;
  }

  close() {
    this.routerService.navigateBack();
  }

  showToolTip(): boolean {
    return this.settingsService.settings.viewMode.showTooltips;
  }
}
